import { fetchApiData , fetchApiDataV2, updateApiDataV2, fetchPublicApi} from "../../utils/utils"

export const getShowDetails=async (appInfo,showId)=>{
    const api=`show/details/${showId}`
    return await fetchApiDataV2(appInfo,api)
}
export const getSimilarVideos=async (appInfo,showId)=>{
    const api=`show/similar/${showId}`
    return await fetchApiDataV2(appInfo,api)
}

export const joinChallenge = async (appInfo, challengeId) => {
    const api = "challenge/join";
    const location = {
        path: "common",
        values: { challenge_id: challengeId }
    };
    return await updateApiDataV2(appInfo, api, location);
};

export const leaveChallenge = async (appInfo, challengeId) => {
    const api = "challenge/leave";
    const location = {
        path: "common", 
        values: { challenge_id: challengeId }
    };
    return await updateApiDataV2(appInfo, api, location);
};

export const getRedirectDetails = async () => {
    const showCategoryURL = window.location.href
    const api = `redirect?url=${showCategoryURL}`
    return await fetchPublicApi(api)
}

export const fetchWatchlistShows= async (appInfo) => {
    const api = "show/watchlistV2";
    return await fetchApiDataV2(appInfo,api)
}